import { createAction } from "redux-actions";
import { DashboardStepConstants } from "./dashboardStepConstants";

export const setDashboardStep = createAction(
    DashboardStepConstants.SET_DASHBOARD_STEP
);
